export default __webpack_public_path__ + "static/media/falcon-join.5de8c815.svg";